exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link {\n  font-weight: bold;\n  color: #348D48;\n}", ""]);

